<div *ngIf="todoService.todoList.length === 0">
  Add something to do today!
</div>

<div *ngIf="todoService.todoList.length > 0">
  <nav class="nav nav-todo">
    <ul>
      <li><a (click)="onClearAll()">Clear all</a></li>
    </ul>
  </nav>

  <ul class="todo-list">
    <li *ngFor="let todo of todoService.todoList |
      sort: todoService.settings.sortOrder |
      hideCompleted: todoService.settings.hideCompleted |
      incompleteFirst: todoService.settings.incompleteFirst"
        [className]="todo.timeCompleted !== null ? 'todo todo-done' : 'todo'"
        (click)="onTodoClick(todo.id)">
      {{ todo.task }}
    </li>
  </ul>
</div>
